import { Modal as AntdModal } from "antd";
import "./style.scss";
import { CloseIconPrimary } from "assets/icons";

function Modal({
  isOpen,
  onOk,
  onCancel,
  title,
  children,
  footer = null,
  closable = false,
  closeIcon = <CloseIconPrimary />,
  width = 440,
  className,
  wrapClassName,
  rootClassName,
  centered,
  ...props
}) {
  return (
    <AntdModal
      centered={centered}
      className={className}
      wrapClassName={wrapClassName}
      rootClassName={rootClassName}
      width={width}
      title={title}
      open={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      footer={footer}
      closable={closable}
      closeIcon={closeIcon}
      {...props}
    >
      {children}
    </AntdModal>
  );
}

export default Modal;
